<template>
  <div class="iap-email-in-use-notification">
    <UtdNotification id="iapEmailInUseNotification"
                     notification-mode="warning"
                     :has-close-notification="true"
                     @closed="emit('closed')">
      <template #title>
        You already have an account with this email address
      </template>
      <template #default>
        <p class="iap-email-in-use-notification__body">
          Sign in with this email or continue creating an account
        </p>
      </template>
      <template #listContent>
        <div class="iap-email-in-use-notification__actions">
          <UtdButton button-size="small"
                     button-style="clean"
                     @click="handleSignIn">
            Sign In
          </UtdButton>

        </div>
      </template>
    </UtdNotification>
  </div>
</template>

<script setup>
import UtdNotification from '_acaSrc/components/shared/utd/UtdNotification.vue';
import UtdButton from '_acaSrc/components/shared/stdlib/UtdButton.vue';
import { getWindow } from '_acaSrc/utility/DOM';

const emit = defineEmits([ 'closed', 'use-different-email' ]);

const handleSignIn = () => {
    getWindow().location.href = '/login-register';
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.iap-email-in-use-notification {
    .ds1-ph-1();
    .ds1-mb-2();

    :deep(.utd-notification) {
        .ds1-mt-0();
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid @WKCE-BLUE;
        border-left: 6px solid @WKCE-BLUE;

        .utd-notification-warning,
        .utd-notification-warn {
            color: @WKCE-BLUE;
        }

        .utd-notification-icon {
            color: @WKCE-BLUE !important;
        }
    }
}

.iap-email-in-use-notification__body {
    .ds1-ma-0();
    .ds1-mb-2();
}

.iap-email-in-use-notification__actions {
    .ds1-mt-2();
    display: flex;
    gap: 8px;

    :deep(.utd-button) {
        background-color: @WKCE-GRAY-TINT5;
        color: @WKCE-BLACK;
    }
}
</style>

